<template>
    <div class="lead-form">
        <!--<h4>
            {{ trans('title') }}
        </h4>-->

        <!-- <form @keydown="form.errors.clear($event.target.name)"> -->
            <my-input
                ref="leads_first_name"
                v-model="form.first_name"
                name="first_name"
                :label="trans('labels.first_name')"
            />

            <error-span :error="form.errors.get('first_name')"></error-span>

            <my-input
                v-model="form.last_name"
                name="last_name"
                :label="trans('labels.last_name')"
            />

            <error-span :error="form.errors.get('last_name')"></error-span>

            <my-input
                v-model="form.email"
                name="email"
                type="email"
                :label="trans('labels.email')"
            />

            <error-span :error="form.errors.get('email')"></error-span>

            <my-input
                v-model="form.phone"
                name='phone'
                type="phone"
                :label="trans('labels.phone')"
            />

            <error-span :error="form.errors.get('phone')"></error-span>

            <my-textarea
                v-model="form.message"
                name="message"
                :label="trans('labels.message')"
            />

            <error-span :error="form.errors.get('message')"></error-span>

            <template v-if="$root.country != 'it'">
                <div class="privacy-policy" v-html="trans('agreements.privacy.label', { link: trans('agreements.privacy.link') })"></div>
                <marketing-checkbox v-if="$root.country != 'it'" v-model="form.marketing" id="lead-marketing-checkbox" :lang="lang" />
            </template>

            <template v-else>
                <privacy-checkbox
                    v-model="form.privacy"
                    name="privacy"
                    id="lead-privacy-checkbox"
                    :textPrivacy="lang.agreements.privacy.label"
                    :langPrivacy="langPrivacy"
                    modal="privacy"
                />
                <error-span :error="form.errors.get('privacy')" />

                <marketing-checkbox v-model="form.marketing" id="lead-marketing-checkbox" :lang="lang" />
                <marketing-agency-checkbox v-model="form.marketing_agency" id="lead-marketing-agency-checkbox" :lang="lang" />
            </template>

            <div class="form-check">
                <tooltip :text="langPrivacy.privacy_agency">
                    <button
                        @click="onSubmit()"
                        class="btn btn-network mt-1"
                        :class="'btn-network-' + estate.network"
                    >
                        {{ trans('labels.send') }}
                    </button>
                </tooltip>
            </div>
        <!-- </form> -->
    </div>
</template>

<script>
import { Form } from '../classes/Form'
import MarketingCheckbox from './form/MarketingCheckbox'
import MarketingAgencyCheckbox from './form/MarketingAgencyCheckbox'
import PrivacyCheckbox from './form/PrivacyCheckbox'
import Tooltip from './Tooltip'

export default {
    components: {
        'marketing-checkbox': MarketingCheckbox,
        'marketing-agency-checkbox': MarketingAgencyCheckbox,
        'privacy-checkbox': PrivacyCheckbox,
        'tooltip': Tooltip,
    },

    props: {
        estate: {
            type: Object,
            required: true,
        },

        solutionId: {
            type: Number,
        },
    },

    data() {
        return {
            form: new Form({
                agency_id: this.estate.agency.id,
                current_page: window.location.href,
                email: '',
                estate_id: this.estate.id,
                estate_type: this.estate.ad_type,
                first_name: '',
                last_name: '',
                marketing: false,
                marketing_agency: false,
                privacy: false,
                message: '',
                phone: '',
            }),

            rules: {
                email: ['required', 'email'],
                first_name: ['required'],
                last_name: ['required'],
                // privacy: this.$root.country == 'it' ? ['required'] : ['nullable'],
                phone: ['required', 'numeric', 'min:9'],
            },
        }
    },

    computed: {
        lang() {
            return this.$root.lang.lead_form
        },

        langPrivacy() {
            return this.$root.lang.privacy;
        },
    },

    mounted() {
        if (this.$root.country == 'it') {
            this.rules.privacy = ['required']
        }

        if (this.solutionId) {
            this.form.message = this.trans('solution_message', { id: this.solutionId })
        }

        window.events.$on('leadFormFocus', () => {
            this.$refs.leads_first_name.setFocus()
        })
    },

    methods: {
        onSubmit() {
            if (!this.form.validate(this.rules)) {
                return false
            }

            this.form.post('/api/leads')
                .then(({response}) => {
                    this.form.agency_id = this.estate.agency.id
                    this.form.estate_id = this.estate.id

                    if (window.criteo_code && response.id) {
                        let deviceType = this.$root.is_mobile ? 'm' : 'd';
                        window.criteo_q = window.criteo_q || [];
                        window.criteo_q.push(
                            { event: "setAccount", account: window.criteo_code },
                            { event: "setSiteType", type: deviceType },
                            { event: "trackTransaction", 
                                id: response.id, 
                                item: [{ 
                                        id: this.estate.id, 
                                        price: this.estate.price, 
                                        quantity: 1
                                    }
                                ]
                            }
                        );
                    }

                    if (typeof ga != 'undefined') {
                        ga('send', 'pageview', '/obiettivi/form/schedaimmobile/compilato/')
                    }
            
                    flash(this.lang.flash.success)
                })
                .catch(response => {
                    if (response.status !== 419) {
                        flash(response.data.message, 'warning')
                    }
                })
        },
    },
}
</script>